import React, { useState } from 'react'
import './App.css';
import { debounce, Grid, CircularProgress } from '@material-ui/core';
import ProductOptions from './components/ProductOptions';
import Categories from './components/Categories';
import ProductReviews from './components/ProductReviews';
import ProductDetails from './components/ProductDetails';
import Products from './components/Products';

const Desktop = (props) => {
  const [selectedCategorySlug, setSelectedCategorySlug] = useState('');
  const [selectedProduct, setSelectedProduct] = useState('');

  console.log("TEST", selectedProduct, selectedCategorySlug);
  
  return (
    <>
      <Grid container direction="column" alignItems="center" justifyContent="space-around" style={{ minHeight: '400px' }}>

      

        <Grid container direction="row" alignItems="flex-start" justifyContent="space-around">
          <Grid item xs={9}>
            <Categories {...props} selectedCallback={setSelectedCategorySlug} />
            <Products {...props} categorySlug={selectedCategorySlug} selectedCallback={setSelectedProduct} />
            <Grid container direction="row" justifyContent="space-around" alignItems="flex-start" style={{ marginTop: '20px', padding: '8px', paddingLeft: '23px', paddingRight: '23px' }}>
                <Grid item xs={6}>
                  <ProductDetails product={selectedProduct} />
                </Grid>
                <Grid item xs={6}>
                  <ProductReviews {...props}  product={selectedProduct} productID={selectedProduct.id} />
                </Grid>
              </Grid>
            </Grid>
          <Grid item xs={3} style={{ backgroundColor: '#F7F7F7' }}>
            <ProductOptions {...props} categorySlug={selectedCategorySlug} product={selectedProduct} />
          </Grid>

          {
              !selectedProduct ?
              <Grid style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', alignSelf: 'center', }} xs={12} item>
                <CircularProgress color="inherit" />
              </Grid> : null
            }      
          
        </Grid>
      </Grid>
    </>
  );
}

export default Desktop;
